import { Footer } from './Footer';
import { Header } from './Header';

import './styles.css';

export const NotFound404 = (props?: any) => {
  return (
    <div className="w404wrap">
      <Header></Header>
      <div className="wrapper404">
        <span style={{ color: '#ed1c24' }}>404</span> <span style={{ color: '#d3d3d3' }}>/</span>{' '}
        <span style={{ color: '#333333' }}>Stranica nije pronađena</span>
        <br></br>
        <div className="wrapperInside">
          Nažalost, stranica koju tražite nije pronađena. Klikom na dugme ispod možete se vratiti na naslovnicu portala.
        </div>
        <button className="btnBack lgText lgHeight">POVRATAK NA NASLOVNICU</button>
      </div>
      <Footer></Footer>
    </div>
  );
};
